export default __webpack_public_path__ + "static/media/step-two-forklift.c8430f39.jpg";